import { FormControl, Grid, FormControlLabel, Switch, FormGroup } from "@mui/material";

import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { maxLength, TextInput } from "react-admin";
import { CitizenshipIds } from "utils/constants";
import { getUniName } from "utils/tenants";
import { settings } from "app";

const HealthInsuranceSection = ({
  state,
  handleChange,
  isDisable,

  setNotSubjectToInsurance,
  notSubjectToInsurance,
  SectionTitle,
  setState,
  isKSK,
  citizenshipId,
  isForeigner,
}) => {
  const { getValues } = useFormContext();

  const typeCitizensip = getValues("userInfo.citizenshipId");

  const showAdditionalHealthInsuranceNumber = isForeigner;

  const isESKSK = isKSK && citizenshipId === CitizenshipIds.EuForeigners;

  const tenant = settings.tenant;
  const uniDisplayName = getUniName(tenant);

  const handlenotSubjectToHealthInsurance = () => {
    setNotSubjectToInsurance(!notSubjectToInsurance);
  };

  useEffect(() => {
    if (notSubjectToInsurance) setState([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notSubjectToInsurance]);

  useEffect(() => {
    if (isESKSK || typeCitizensip === CitizenshipIds.EuForeigners) setNotSubjectToInsurance(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeCitizensip]);

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <>
          <FormControlLabel
            sx={{ paddingLeft: "2rem" }}
            control={
              <Switch
                checked={notSubjectToInsurance}
                onChange={handlenotSubjectToHealthInsurance}
              />
            }
            label={`Не подлежи на осигуряване от ${uniDisplayName}`}
          />

          <Grid
            item
            xs={12}
          >
            <SectionTitle title={"Формуляр за здравно осигуряване"} />
          </Grid>
          <Grid
            container
            spacing={2}
            pl={4}
          >
            {showAdditionalHealthInsuranceNumber && (
              <Grid
                item
                xs={12}
                md={4}
              >
                <TextInput
                  source="healthInsuranceNumber"
                  label={"Допълнителен идентификационен номер"}
                  validate={[maxLength(50)]}
                  readOnly={isDisable}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            item
            xs={12}
          >
            <FormControl
              component="fieldset"
              variant="standard"
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.HasEmploymentIncome}
                      onChange={handleChange}
                      name="HasEmploymentIncome"
                      disabled={isDisable}
                    />
                  }
                  label="Получавам доходи от трудова дейност"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.ReceivesSurvivorPension}
                      onChange={handleChange}
                      name="ReceivesSurvivorPension"
                      disabled={isDisable}
                    />
                  }
                  label="Получавам наследствена пенсия"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.HasOtherTaxableHealthIncome}
                      onChange={handleChange}
                      name="HasOtherTaxableHealthIncome"
                      disabled={isDisable}
                    />
                  }
                  label="Получавам други доходи, върху които се дължат здравноосигурителни вноски по реда на чл.40, ал.1 от 330"
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </>
      </Grid>
    </>
  );
};
export default HealthInsuranceSection;
